export default __webpack_public_path__ + "static/media/verifiedIcon.c910914f.svg";